<div class="content-block">
  <div class="dx-card responsive-paddings px-4">
    <div class="logos-container">
      <img src="assets/images/cdr-logo.jpg" title="CDR Disposal logo" style="height: 150px" />
    </div>

    <h2>Welcome to <b>CDR Disposal</b>!</h2>
    <p>@if (!(account$ | async)) {
      <button (click)="login()">Login</button>
    }</p>

    @if (account$ | async; as account) {
      <div>
        <div style="font-size: 1.2em; cursor: pointer">
          @if (!(user$ | async)) {
            <div (click)="showClaims = !showClaims">The account "{{account.username}}" is not setup as a user for CDR</div>
          }
          @if (user$ | async; as user) {
            <div (click)="showClaims = !showClaims">{{ user?.firstName }} {{ user?.lastName }}</div>
          }
        </div>
        @if (showClaims) {
          <div class="mx-3">
            <!-- <div>{{ account | json }}</div> -->
            <div>{{ account?.name }}</div>
            <div>{{ account?.localAccountId }}</div>
            <div>{{ account?.username }}</div>
          </div>
        }
        <p><button (click)="logout()" class="mt-4">Logout</button></p>
        <!-- <button (click)="openRentalForm()" class="mt-4">Rental Form</button> -->
      </div>
    }
    <p class="mt-4">version {{ appInfo?.appVersion }}</p>
  </div>
</div>
